import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/Core/services/notification.service';
import { ToasterService } from 'src/app/Core/services/toaster.service';

@Component({
  selector: 'app-test-notification',
  templateUrl: './test-notification.component.html',
  styleUrls: ['./test-notification.component.css']
})
export class TestNotificationComponent implements OnInit {
  notification: any;
  testEmails: string = '';
  notificationId: string = '';
  errorMessage: string = '';

  constructor(
    private notificationService: NotificationService, 
    private router: Router, 
    private route: ActivatedRoute,
    private toaster: ToasterService
  ) {}

  ngOnInit() {
    this.notification = this.notificationService.getNotificationData();
      this.notificationId = this.notification.id 
  }

  navigateBack() {
    this.router.navigate(["/notification-list"]);
  }

  testNotification() {
    if (!this.testEmails) {
      this.errorMessage = "Enter the Test emails";
      return;
    }

    const emailArray = this.testEmails.split(',').map(email => email.trim());
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    const invalidEmails = emailArray.filter(email => !emailRegex.test(email));

    if (invalidEmails.length > 0) {
      this.errorMessage = `Invalid email(s): ${invalidEmails.join(', ')}`;
      return;
    }

    this.notificationService.testNotification(this.notificationId, emailArray).subscribe(
      response => {
        this.toaster.openDialogBox("Notification sent to test emails successfully",true)
      },
      error => {
        console.error('Error sending test emails', error);
        if (error.status === 403) {
          this.toaster.openDialogBox("You don't have the required permission", false);
        } 
        if (error.status === 400){
          this.toaster.openDialogBox("This notification is already published", false);
        }
        this.testEmails = '';
      }
    );
  }
}
